import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StopDefinitionPage } from './stop-definition.page';

const routes: Routes = [
  {
    path: '',
    component: StopDefinitionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StopDefinitionPageRoutingModule {}
